import React from "react";
import "./Moving.css";
import truckImage from "../../asset/trucks-travelling-by-road.png";

export function MovingSection() {
  return (
    <div id="moving" className="green-container pt-5 pb-5">
      <div className="mx-5">
        <h1 className="fs-1 fw-bold font-monospace text-center mb-5">
          Umzugsservice
        </h1>

        <div className="d-flex justify-content-around align-items-center">
          <img
            className="responsive-img"
            style={{ maxWidth: "360px" }}
            src={truckImage}
            alt="Umzug"
          />

<p className="fs-3 text-start" style={{ maxWidth: "700px" }}>
  Ein Umzug bedeutet oft Stress – wir sorgen dafür, dass er reibungslos und
  entspannt abläuft. Von der Planung bis zur Durchführung stehen wir Ihnen
  zuverlässig zur Seite. Unser erfahrenes Team kümmert sich um den sicheren
  Transport Ihrer Möbel und persönlichen Gegenstände.

  Ob kleiner Privatumzug oder großer Firmenumzug – wir bieten Ihnen
  maßgeschneiderte Lösungen, die genau zu Ihren Anforderungen passen. Auf Wunsch
  übernehmen wir auch das Verpacken, den Ab- und Aufbau Ihrer Möbel sowie
  zusätzliche Services.

  Vertrauen Sie auf unsere Erfahrung und lassen Sie uns Ihren Umzug einfach und
  effizient gestalten.
</p>
        </div>
      </div>
    </div>
  );
}